export default "__VITE_ASSET__31c740da__"